import SectionHeading from '../../ui/SectionHeading/SectionHeading.jsx';
import Card from '../../ui/Card/Card.jsx';
import styles from './FeatureGrid.module.css';

const features = [
  {
    icon: '◧',
    title: 'Interactive device mockups',
    text: 'Show a working preview of your interface directly in the page — browser and phone frames included.',
  },
  {
    icon: '⌗',
    title: 'A real design system',
    text: 'Color, type, spacing, and components are all driven by shared tokens, so a rebrand is a values change, not a rebuild.',
  },
  {
    icon: '⤢',
    title: 'Built to scale',
    text: 'Every section is a component. Compose new pages from the same library without starting from a blank canvas.',
  },
  {
    icon: '◎',
    title: 'Accessible by default',
    text: 'Visible focus states, semantic markup, and reduced-motion support are part of every component, not an afterthought.',
  },
  {
    icon: '⇲',
    title: 'Responsive to every screen',
    text: 'Layouts adapt fluidly from a widescreen monitor down to a phone in one hand, with no separate mobile template.',
  },
  {
    icon: '⌁',
    title: 'SEO-ready pages',
    text: 'Semantic structure and clean markup mean your product is as easy for search engines to read as it is for people.',
  },
];

export default function FeatureGrid() {
  return (
    <section className={styles.section}>
      <div className="container">
        <SectionHeading
          eyebrow="Why Solvora"
          title="Everything a launch page needs, nothing it doesn't"
          description="A conversion-focused system built from reusable parts — so you spend your time on your product, not your page."
        />
        <div className={styles.grid}>
          {features.map((f) => (
            <Card key={f.title}>
              <span className={styles.icon} aria-hidden="true">{f.icon}</span>
              <h3 className={styles.title}>{f.title}</h3>
              <p className={styles.text}>{f.text}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
